export { MOTIcon } from './mot'
